import axios from 'axios'
import {
  BankAccount,
  BankAccountSchema,
  createBankAccountRequestSchema,
  PaginatedProgramBankAccountsList,
  PaginatedProgramBankAccountsListSchema,
  Processor,
  ProcessorSchema,
  UpdateBankAccountRequest,
} from './schema'
import { parseRequestError } from '@/app/common/utilities'
import z from 'zod'

export const getPaginatedProgramBankAccountLists = async function (
  programId: number,
  currentPage: number,
  recordsPerPage: number = 20,
  search?: string
): Promise<PaginatedProgramBankAccountsList> {
  try {
    const response = await axios.get(`bank_accounts`, {
      params: {
        program_id: programId,
        paginate: 1,
        per_page: recordsPerPage,
        page: currentPage,
        search: search !== '' ? search : undefined,
      },
    })
    return PaginatedProgramBankAccountsListSchema.parse(response.data)
  } catch (error) {
    throw new Error(parseRequestError(error).message)
  }
}

export const getBankAccountDetail = async (
  id: string
): Promise<BankAccount> => {
  try {
    const response = await axios.get(
      `bank_accounts/${encodeURIComponent(String(id))}`
    )
    return BankAccountSchema.parse(response.data)
  } catch (e) {
    throw new Error(parseRequestError(e).message)
  }
}

type createBankAccountReq = z.input<typeof createBankAccountRequestSchema>

export const getProcessors = async (
  programId: number
): Promise<Processor[]> => {
  try {
    const response = await axios.get('get_processors', {
      params: { program_id: programId },
    })
    return z.array(ProcessorSchema).parse(response.data)
  } catch (error) {
    throw new Error(parseRequestError(error).message)
  }
}

export const getAllProgramBankAccounts = async (
  programId: number
): Promise<BankAccount[]> => {
  try {
    const response = await axios.get('bank_accounts', {
      params: { program_id: programId },
    })
    return z.array(BankAccountSchema).parse(response.data)
  } catch (error) {
    throw new Error(parseRequestError(error).message)
  }
}

export const createBankAccount = async (
  requestBody: createBankAccountReq
): Promise<BankAccount> => {
  try {
    const response = await axios.post('bank_accounts', requestBody)
    return BankAccountSchema.parse(response.data)
  } catch (error) {
    throw new Error(parseRequestError(error).message)
  }
}

export const updateBankAccount = async ({
  id,
  ...body
}: UpdateBankAccountRequest): Promise<BankAccount> => {
  try {
    const response = await axios.put(
      `bank_accounts/${encodeURIComponent(String(id))}`,
      body
    )
    return BankAccountSchema.parse(response.data)
  } catch (error) {
    throw new Error(parseRequestError(error).message)
  }
}
